import { render } from "./InfoTagsItem.vue?vue&type=template&id=2f6a186c&scoped=true"
import script from "./InfoTagsItem.vue?vue&type=script&lang=js"
export * from "./InfoTagsItem.vue?vue&type=script&lang=js"

import "./InfoTagsItem.vue?vue&type=style&index=0&id=2f6a186c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6a186c"]])

export default __exports__